import { BaseService, Service } from "/@/cool";
import type { SettleAccountForm } from "/$/commission/types/orderCommission";

@Service("settleAccount")
class SettleAccountService extends BaseService {
	constructor() {
		super();
		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["info"] = prefix + "info";
		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
	}

	info(data: { shop_id: number }) {
		return this.request({
			url: "/info",
			method: "POST",
			data
		});
	}

	add(data: SettleAccountForm) {
		return this.request({
			url: "/add",
			method: "POST",
			data: {
				account_type: 1,
				...data
			}
		});
	}

	update(data: SettleAccountForm & { id: number }) {
		return this.request({
			url: "/update",
			method: "POST",
			data: {
				account_type: 1,
				...data
			}
		});
	}
}

export default SettleAccountService;
